import React from 'react';
import ErrorImage from '../../../../assets/images/no-found.png';

import { Button, Container } from './styled';

const NotFoundView = ({ goBackButton }: any) => (
  <Container data-testid="event-not-found-view">
    <div>
      <div className="image-error">
        <img src={ErrorImage} alt="ErrorImage" />
      </div>
      <div className="text">
        <h1 className="title">Lo sentimos, no encontramos el link.</h1>
        <div className="subtitle">
          El enlace no está disponible o ha caducado. Por favor, inténtalo de
          nuevo y vuelve a la página de inicio.
        </div>
      </div>
    </div>

    <Button
      className="button"
      onClick={goBackButton}
      data-testid="go-back-button"
    >
      Ir a servicios
    </Button>
  </Container>
);

export default NotFoundView;
